import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { createI18n, type I18n, type LocaleMessages } from 'vue-i18n';

import { isPlatformIs24 } from '@/helpers/Platform/platform';

export const DEFAULT_LANGUAGE = HgSupportedLanguage.DE;
enum LocaleFileSuffix {
  HG = 'hg',
  IS24 = 'is24',
}

const i18n = createI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  silentFallbackWarn: true,
  legacy: false,
  missing: (currentLocale, key) =>
    console.warn(`Missing translations for "${key}" in "${currentLocale}"`),
  messages: {},
});

export function setLocale(locale: HgSupportedLanguage): void {
  i18n.global.locale.value = locale;
}

export function initI18n(translations: LocaleMessages<never>, locale = DEFAULT_LANGUAGE): I18n {
  setLocale(locale);
  i18n.global.setLocaleMessage(locale, { ...translations });

  return i18n;
}

export async function safeLoadTranslations(locale: HgSupportedLanguage): Promise<void> {
  try {
    await loadTranslations(locale);
  } catch (err) {
    console.error('Could not load locales', err);
  }
}

export async function loadTranslations(locale: HgSupportedLanguage): Promise<void> {
  const localeSuffix = isPlatformIs24() ? LocaleFileSuffix.IS24 : LocaleFileSuffix.HG;
  // eslint-disable-next-line import/dynamic-import-chunkname
  const localeLoaded = await import(`@/i18n/${locale}-${localeSuffix}.ts`);
  i18n.global.setLocaleMessage(locale, { ...localeLoaded.default });
}

export async function setLocaleBeforeRouteChange(locale: HgSupportedLanguage): Promise<void> {
  if (!(locale in i18n.global.messages)) {
    await safeLoadTranslations(locale);
  }

  setLocale(locale);
}
